import { gql } from "apollo-boost";

export const CREATE_FABRIC = gql`
mutation CreateFabric($data: FabricInput!) {
  createFabric(data: $data) {
    id
    name
    price
    image
    imageString
    shop {
      id
    }
    isDeleted
    createdAt
    updatedAt
    note
  }
}
`

export const DELETE_FABRIC = gql`
mutation DeleteFabric($where: FabricWhereInputOne!) {
  deleteFabric(where: $where) {
    id
  }
}
`
